import { render, staticRenderFns } from "./AdminSetup.vue?vue&type=template&id=57e2a525&"
import script from "./AdminSetup.js?vue&type=script&lang=js&"
export * from "./AdminSetup.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports